// src/lib/supabase.ts
import { createClient } from '@supabase/supabase-js';
import { config } from '../config/env';

// There are deliberately no hardcoded fallbacks: every environment points at
// its own Supabase project through REACT_APP_SUPABASE_URL / _ANON_KEY.
// Jest runs without a .env, so tests get an inert local placeholder instead.
const isTest = process.env.NODE_ENV === 'test';
const supabaseUrl = config.supabase.url || (isTest ? 'http://localhost:54321' : '');
const supabaseAnonKey = config.supabase.anonKey || (isTest ? 'test-anon-key' : '');

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY. Copy .env.example to .env ' +
      'and fill in your Supabase project values (see docs/handoff/05_ENVIRONMENT_VARIABLES.md).'
  );
}

// Create a single Supabase client instance
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Export the client as default for convenience
export default supabase;
